import { ComponentTypes } from '../Data/Components';

export const isSupplierMatch = (component) => {
  return component?.component?.type === ComponentTypes.SUPPLIER_MATCH;
};

export const isSelectAndConnect = (component) => {
  return component?.component?.type === ComponentTypes.SELECT_AND_CONNECT;
};

export const getSelectAndConnectComponent = ({ components }) => {
  return Object.values(components).find((component) =>
    isSelectAndConnect(component)
  );
};

export const hasSingleOption = (component) => {
  const matches = component?.input?.options;
  return typeof matches === 'object' && matches.length === 1;
};

export const getSupplierMatchComponent = ({ components }) => {
  return Object.values(components).find((component) =>
    isSupplierMatch(component)
  );
};
